module.exports = __webpack_public_path__ + "static/media/PastEventsDesktop.68f49c37.jpg";